import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MarianomGeneral } from '../marianom-general.service';
import { EcommerceGenericoService, HistorialPedidos } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'historial-mmax-compras',
  templateUrl: './historial-mmax-compras.component.html',
  styleUrls: ['./historial-mmax-compras.component.scss']
})

export class HistorialMMaxComprasComponent implements OnInit {
  @Input() modo: string='normal';

  cargando: boolean = true;
  historial: HistorialPedidos[]=[];
  hayPedidos : boolean = true;
  constructor(private serv: MarianomGeneral, private genServ : EcommerceGenericoService,private router: ActivatedRoute) {
    
  }

  async ngOnInit() {
    this.detectarPagoExitoso();
    if (localStorage.getItem('currentUser') == null) {
      this.serv.navigator.goLandPage(this.router);
    } else {
      this.cargarPedidos();
      this.router.data.subscribe(data => {
        this.modo = data['mode'] || this.modo || 'normal';
      })
    }
  }

  detectarPagoExitoso() {
    this.router.queryParams.subscribe(params => {
      const status = params['status'] || params['collection_status'];
      if (status === 'approved') {
        // Si el pago fue aprobado, limpiamos el carro y vamos a la pantalla final
        this.genServ.resetEccomerce();
        this.serv.navigator.endline(this.router);
      }
    });
  }

  reload() {
    this.historial = [];
    this.cargando = true;
    this.cargarPedidos();
  }

  cargarPedidos(){
    this.genServ.getHistorialDePedidos().subscribe({
      next:respuestaPedidos =>{
        const pedidos = this.genServ.obtenerHistorialDePedidosCargados();
        this.historial = this.genServ.ordenarporFechaHistorial(pedidos);
        this.cargando = false;
        this.hayPedidos = this.historial.length !== 0;
      },
      error: err => {
        console.error('Historial -> Error al cargar pedidos:', err);
        this.cargando = false;
        this.hayPedidos = false;
      }
    });
  }

  recompra(jistoriaRecompra: HistorialPedidos) {
    this.genServ.cargarEstePedidoDeHistorialEnCart(jistoriaRecompra);
    this.serv.navigator.irResumenCompra(this.router)
  }

  verDetalle(detalle: HistorialPedidos) {
    this.genServ.verPedido(detalle);
    this.serv.navigator.goDetallePedido(this.router);
  }
}
